export default [
  // Redirect to '/dash' when user click on home icon from breadcrumb. home path is '/' so redirect to '/dash'
  {
    path: "/",
    name: "home",
    beforeEnter: (to, from, next) => {
      window.location.href = "/dash";
    },
    meta: {
      authRequired: true,
      pageTitle: "Home",
      breadcrumb: [
        {
          text: "Home",
          active: true,
        },
      ],
    },
  },
  {
    path: "/dash",
    name: "findEmail",
    component: () => import("@/modules/findEmail/pages/FindEmail.vue"),
    meta: {
      authRequired: true,
      pageTitle: "Your Prospect List",
      breadcrumb: [
        {
          text: "Your List",
          active: true,
        },
      ],
    },
  },
];
